import React from "react";
import { NAAVI_LOGO, NAAVI_LOGO_LIGHT } from "../../data/content";

/**
 * Inline SVG re-imagining of the logo shapes for decorative motifs
 * across the site — cornflower square, lime flower, teal rainbow, turquoise circle.
 */

export const ShapeSquare = ({ className = "", size = 40, color = "#648DE5" }) => (
  <div
    className={`shape-square ${className}`}
    style={{ width: size, height: size, background: color }}
    aria-hidden="true"
  />
);

export const ShapeCircle = ({ className = "", size = 40, color = "#3AB0D6" }) => (
  <div
    className={`rounded-full ${className}`}
    style={{ width: size, height: size, background: color }}
    aria-hidden="true"
  />
);

export const ShapeFlower = ({ className = "", size = 56, color = "#C6D947" }) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 64 64"
    fill="none"
    aria-hidden="true"
  >
    <g fill={color}>
      <circle cx="32" cy="12" r="9" />
      <circle cx="32" cy="52" r="9" />
      <circle cx="12" cy="32" r="9" />
      <circle cx="52" cy="32" r="9" />
      <circle cx="18" cy="18" r="8" />
      <circle cx="46" cy="18" r="8" />
      <circle cx="18" cy="46" r="8" />
      <circle cx="46" cy="46" r="8" />
      <circle cx="32" cy="32" r="9" fill="#0F1B47" />
    </g>
  </svg>
);

export const ShapeRainbow = ({ className = "", size = 80, color = "#5BC4B8" }) => (
  <svg
    className={className}
    width={size}
    height={size / 2 + 4}
    viewBox="0 0 80 44"
    fill="none"
    aria-hidden="true"
  >
    <path
      d="M4 40 A36 36 0 0 1 76 40"
      stroke={color}
      strokeWidth="8"
      fill="none"
      strokeLinecap="round"
    />
    <path
      d="M16 40 A24 24 0 0 1 64 40"
      stroke={color}
      strokeWidth="8"
      fill="none"
      strokeLinecap="round"
      opacity="0.7"
    />
    <path
      d="M28 40 A12 12 0 0 1 52 40"
      stroke={color}
      strokeWidth="8"
      fill="none"
      strokeLinecap="round"
      opacity="0.45"
    />
  </svg>
);

export const NaaviLogo = ({ className = "", height = 40, variant = "dark" }) => (
  <img decoding="async" loading="lazy"
    src={variant === "light" ? NAAVI_LOGO_LIGHT : NAAVI_LOGO}
    alt="Naavi Early Years"
    style={{ height, width: "auto" }}
    className={className}
    data-testid="naavi-logo"
  />
);
